import React from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

/**
 * @class Scrollspy
 */
var SPY_INTERVAL = 100;
var Scrollspy = /** @class */ (function (_super) {
    __extends(Scrollspy, _super);
    function Scrollspy(props) {
        var _this = _super.call(this, props) || this;
        _this.isInView = function (element) {
            if (!element) {
                return false;
            }
            var offset = _this.props.offset;
            var rect = element.getBoundingClientRect();
            return rect.top >= 0 - offset && rect.bottom <= window.innerHeight + offset;
        };
        _this.state = {
            items: []
        };
        return _this;
    }
    Scrollspy.prototype.spy = function () {
        var _this = this;
        var items = this.props.ids
            .map(function (id) {
            var element = document.getElementById(id);
            if (element) {
                return {
                    inView: _this.isInView(element),
                    element: element
                };
            }
            else {
                return;
            }
        })
            .filter(function (item) { return item; });
        var firstTrueItem = items.find(function (item) { return !!item && item.inView; });
        if (!firstTrueItem) {
            return; // dont update state
        }
        else {
            var update = items.map(function (item) {
                return __assign({}, item, { inView: item === firstTrueItem });
            });
            this.setState({ items: update });
        }
    };
    Scrollspy.prototype.componentDidMount = function () {
        var _this = this;
        this.timer = window.setInterval(function () { return _this.spy(); }, SPY_INTERVAL);
    };
    Scrollspy.prototype.componentWillUnmount = function () {
        window.clearInterval(this.timer);
    };
    Scrollspy.prototype.scrollTo = function (element) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    };
    Scrollspy.prototype.renderItems = function () {
        var _this = this;
        var _a = this.props, itemElement = _a.itemElement, activeItemClassName = _a.activeItemClassName, itemClassName = _a.itemClassName;
        return this.state.items.map(function (item, k) {
            return itemElement
                ? React.cloneElement(itemElement, {
                    key: k,
                    className: classnames(itemClassName, item.inView ? activeItemClassName : null),
                    onClick: function () { return _this.scrollTo(item.element); },
                    children: item.element.innerText
                })
                : null;
        });
    };
    Scrollspy.prototype.render = function () {
        var _a = this.props, itemContainerClassName = _a.itemContainerClassName, containerElement = _a.containerElement;
        return containerElement
            ? React.cloneElement(containerElement, {
                className: classnames(itemContainerClassName),
                children: this.renderItems()
            })
            : null;
    };
    Scrollspy.defaultProps = {
        offset: 2,
        ids: [],
        containerElement: React.createElement("ul", null),
        itemElement: React.createElement("li", null)
    };
    return Scrollspy;
}(React.Component));

export default Scrollspy;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0